export const setupWizard = {
  top: {
    title: "Assistente de configuração",
    subtitleFallback: "Configuração básica do anúncio",
    stepCount: "Etapa {current} de {total}",
    closeAria: "Fechar assistente",
    closeTitle: "Fechar",
  },
  intro: {
    title: "Vamos configurar sua acomodação juntos!",
    subBefore: "Vamos guiar você passo a passo para deixar",
    yourListingFallback: "seu anúncio",
    subAfter: "pronto para receber hóspedes. Sem conhecimentos técnicos: você deixará tudo configurado em poucos minutos. 😊",
    start: "Começar!",
    skip: "Agora não, farei isso depois",
  },
  steps: {
    confirmation: {
      label: "Confirmação de reserva",
      desc: "Avisamos o hóspede de que a reserva está confirmada por WhatsApp e e-mail. Desative isso e ele não será notificado. Se ele reservar por uma OTA, a OTA o notifica.",
    },
    welcome: {
      label: "Mensagem de boas-vindas",
      desc: "A mensagem que o hóspede recebe logo após concluir o check-in online, com as boas-vindas e as instruções de chegada.",
    },
    schedule: {
      label: "Agendamento do check-in",
      desc: "Quando você gostaria que enviássemos o link de check-in ao hóspede?",
    },
    hours: {
      label: "Horários de check-in e check-out",
      desc: "A que horas o hóspede pode chegar e sair?",
    },
    locks: {
      label: "Tipo de fechadura",
      desc: "Como o hóspede entra na sua acomodação?",
    },
    authorities: {
      label: "Comunicação às autoridades",
      desc: "Enviamos o informe de viajantes às autoridades por você, sem que você precise fazer nada.",
    },
    services: {
      label: "Serviços",
      desc: "Configure os serviços e comodidades que sua acomodação oferece.",
    },
    policies: {
      label: "Políticas",
      desc: "As regras e condições da sua acomodação.",
    },
    calendar: {
      label: "Prepare seu calendário",
      desc: "Vamos mostrar como deixar seu calendário pronto para receber reservas.",
    },
  },
  nav: {
    back: "Voltar",
    next: "Avançar",
    finish: "Concluir",
  },
  preview: {
    audienceOwner: "O que você vê (anfitrião)",
    audienceGuest: "O que o hóspede vê",
    accommodationFallback: "Acomodação",
    online: "online",
    today: "Hoje",
    captionGuestWeb: "Prévia · web do hóspede",
  },
  schedule: {
    title: "Quando o check-in começa?",
    hint: "Agende quando o agente envia o link de check-in ao hóspede. Aplica-se no nível do anúncio.",
    caption: "Prévia · sequência de check-in",
  },
  // WhatsApp bot sample messages: shown VERBATIM (bilingual ES+EN) in every
  // language because they mirror the actual product message.
  checkin: {
    propFallback: "tu alojamiento",
    greeting: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    quote: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*. Estoy aquí para ayudarte con el proceso de che…",
    subCheckin: "Vamos a hacer el check-in · Let's check-in",
    ok: "Ok",
    chooseLang: "Elige tu idioma",
    langEs: "Español",
    langEn: "English",
    thanks: "*Gracias* 👋 Este es tu link para hacer el Check-In. 😎",
  },
  confirmation: {
    toggleLabel: "Você quer que a confirmação de reserva seja enviada ao hóspede por WhatsApp?",
    toggleHint: "Assim que uma reserva for confirmada, ele receberá esta mensagem com todos os detalhes da estadia. Assim ele sabe que está tudo certo. 😊",
    stateOn: "Sim, enviar",
    stateOff: "Não enviar",
    mapAlt: "Localização da acomodação",
    addressFallback: "Endereço da acomodação",
    caption: "Prévia · mensagem de confirmação",
    propFallback: "sua acomodação",
    guestSample: "Laura García",
    body: "Olá *{guest}* 👋\n\nSua reserva em *{name}* está confirmada ✅\n\nCódigo da reserva: *6233Q1VC5*\nDatas: *05/06/2026* – *07/06/2026* 📅\n\nPor este WhatsApp você pode solicitar o link do seu check-in online e receber as instruções de chegada.\nSe precisar de ajuda antes ou durante a estadia, fale com a gente por aqui 💬",
    cta: "🇬🇧 Para continuar com o check-in, toque no botão *Ok* ou digite *Ok*.",
  },
  policies: {
    guestBubble: "Para continuar com o processo, você deve aceitar nossos termos e condições.",
    termsTitle: 'Regras e Normas · ACOMODAÇÃO TURÍSTICA "{name}"',
    termsBodyLabel: "I.– REGISTRO",
    termsBodyText: "Todo hóspede, seja individual ou parte de um grupo, deve preencher uma ficha de registro individualmente ou por quarto, que será fornecida na chegada ou online.",
    accept: "Aceito os termos e condições",
  },
  guestPreview: {
    continue: "Continuar",
  },
  authorities: {
    ofTotal: "de {total}",
    heading: "Informações exigidas pelo Real Decreto 933/2021 do Governo da Espanha",
    intro: "Conforme o Real Decreto 933/2021, em vigor desde 2 de dezembro de 2024, precisamos coletar os seguintes dados para cumprir as normas de segurança.",
    countryLabel: "País de residência",
    sampleCountry: "🇪🇸 Espanha",
    cityLabel: "Cidade de residência",
    sampleCity: "Málaga",
    addressLabel: "Endereço residencial",
    sampleAddress: "Rua Larios, 77",
    postalLabel: "Código postal residencial",
  },
  locks: {
    embedEmpty: "Adicione primeiro uma unidade ao anúncio para configurar fechaduras e acessos.",
  },
  calendar: {
    iframeTitle: "Prepare seu calendário",
    videoSoon: "O vídeo estará disponível aqui em breve.",
    hint: "Reproduza o vídeo e siga os passos: em pouco tempo seu calendário estará pronto para receber reservas. 🎬",
  },
};
